module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var i = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var i in t) {
      n.d(r, i, function (e) {
        return t[e];
      }.bind(null, i));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 0);
}([function (t, e, n) {
  "use strict";

  function r(t, e) {
    var n = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function i(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? r(Object(n), !0).forEach(function (e) {
        o(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }

    return t;
  }

  function o(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function u(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  n.r(e);

  var a = function () {
    function t(e) {
      var n = this;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.defaultSettings = {
        maximum: 9999,
        minimum: 859,
        maxFont: 9999,
        minFont: 1,
        minWidth: 0,
        maxWidth: 9999,
        fontRatio: 35,
        breakPoints: []
      }, this.settings = i(i({}, this.defaultSettings), e), "undefined" != typeof window && (window.addEventListener("resize", function () {
        return n.handleResize();
      }), this.handleResize());
    }

    var e, n, r;
    return e = t, (n = [{
      key: "handleResize",
      value: function value() {
        var t = this.settings,
            e = this.defaultSettings,
            n = this.settings.breakPoints,
            r = document.body.clientWidth,
            i = n.find(function (t) {
          return r >= (t.minWidth || e.minWidth) && r <= (t.maxWidth || e.maxWidth);
        }) || t,
            o = i.fontRatio,
            u = i.maxFont,
            a = i.minFont,
            c = i.minWidth,
            f = i.maxWidth || e.maxWidth,
            l = c || e.minWidth,
            s = r > f ? f : r < l ? l : r,
            d = u || e.maxFont,
            p = a || e.minFont,
            b = o || e.fontRatio,
            m = s / ("function" == typeof b ? b() : b),
            y = m > d ? d : m < p ? p : m;
        document.documentElement.style.fontSize = "".concat(y, "px");
      }
    }]) && u(e.prototype, n), r && u(e, r), t;
  }();

  e.default = a;
}]);